import { DISABLED_AFTER_TRIAL_ENDS_CLASS_NAME } from "../../users/billing"

/** What the trial-ended roadblock says for a blocked feature (kept free of UI imports). */
export class TrialFinishedRoadblockDialogData {
  constructor(featureName, subscribeReason) {
    this.featureName = featureName
    this.subscribeReason = subscribeReason
  }

  getElementProps() {
    return {
      className: DISABLED_AFTER_TRIAL_ENDS_CLASS_NAME,
      "data-feature-name": this.featureName,
      "data-subscribe-reason": this.subscribeReason,
    }
  }

  get reduxVersion() {
    return {
      featureName: this.featureName,
      subscribeReason: this.subscribeReason,
    }
  }
}
